export default __webpack_public_path__ + "static/media/sxp.8d7ce5cf.svg";